/**
 * Insert string for campaign replace fields (subject, preview, HTML): raw field id only.
 */
export function formatCampaignReplaceInsert(item) {
    return item?.id != null ? String(item.id) : '';
}
